import Repository from "../Repository2"
const get_project_details = "getProjects"
const get_add_ons = "getAddOnsUsage"
const get_add_ons_project_details="getAddOns"

export default {
    getProjecDetails(payload) {
        return Repository.post(transformRoute(get_project_details), payload);
  },
  getAddOnsDetails(payload) {
        return Repository.post(transformRoute1(get_add_ons), payload);
  },
  getAddOns(payload) {
        return Repository.post(transformRoute1(get_add_ons_project_details), payload);
  },
    
}

const transformRoute = route => {
  return `/project/${route}`;
};
const transformRoute1 = route => {
  return `/miniStore/orders/${route}`;
};